import styled from "@emotion/styled"

const HeroScrollCaseContainerBig = styled.div`
  position: absolute;
  top: 75%;
  left: 75%;
  width: 38%;
  transform: translate(-50%, -50%);

  ${({ theme }) => theme.breakpoints.down("3xl")} {
    width: 35%;
    left: 77%;
  }

  ${({ theme }) => theme.breakpoints.down("2xl")} {
    width: 30%;
    left: clamp(75%, calc(0.3482 * 100% + 616.7px), 83%);
  }

  ${({ theme }) => theme.breakpoints.down("xl")} {
    display: none;
  }
`

export default HeroScrollCaseContainerBig
